import React, { useState } from "react";

import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import UserFormSide from "./UserFormSide";
import LoginImg from "../Assets/images/login.svg";

import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../../redux/adminUser";
import ReactTost from "../ReactTost";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import UserCreateBot from "./Bot/UserCreateBot";
import BtnLoader from "../BtnLoader";

const Login = () => {
  const { t } = useTranslation();
  const [isEmailVerified, setEmailVerified] = useState(true);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;

  const role = "user";

  async function checkUser(data) {
    // saving  email because if he is not verified then i will use that email to send a email again
    localStorage.setItem("email", data.email);
    
    if (data.email && data.password) {
      setLoading(true);
      axios
        .post(`${API_URL}/${API_VERSION}/auth/login`, {
          email: data.email,
          password: data.password,
          role,
        })
        .then((response) => {
          setLoading(false);
          if (response.data.user.is_active === false) {
            setType("Danger");
            setMessage(t("You are currently not active."));
            setShowAlert(true);
            navigate("/");
          } else if (response.data.user.isEmailVerified === false) {
            setEmailVerified(false);
            setType("Danger");
            setMessage("");
            setShowAlert(false);
            navigate("/");
          } else if (
            response.data.tokens.access.token &&
            response.data.user.role === "user"
          ) {
            localStorage.setItem("isLogin", true);
            localStorage.setItem("id", response.data.user.id);
            localStorage.setItem("isRole", response.data.user.role);
            localStorage.setItem("EMAIL", response.data.user.email);
            localStorage.setItem("NAME", response.data.user.name);
            localStorage.setItem("token", response.data.tokens.access.token);
            dispatch(
              login({
                userData: true,
                IsUserLevel: response.data.user.role,
              })
            );
            axios
              .get(
                `${API_URL}/${API_VERSION}/bot/user/${response.data.user.id}`,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                }
              )
              .then((botResponse) => {
                console.log("Login:",botResponse);
                if (botResponse.data.length !== 0) {
                  const firstBotId = botResponse.data[0].id;
                  localStorage.setItem("firstBot", firstBotId);
                  navigate(`/my-bots/${firstBotId}`);
                } else {
                  navigate("/my-bots");
                }
              })
              .catch((botError) => {
                setType("Danger");
                setMessage(t("Something went wrong while fetching bot list."));
                setShowAlert(true);
              });
          } else {
            setType("Danger");
            setMessage(t("You are not allowed."));
            setShowAlert(true);
          }
        })
        .catch((error) => {
          setLoading(false);
          setType("Danger");
          setMessage(t("Invalid username or password"));
          setShowAlert(true);
        });
    }
  }
  const resendVerification = async () => {
    try {
      await axios.post(`${API_URL}/${API_VERSION}/auth/resend-verify-email`, {
        email: localStorage.getItem("email"),
      });
      setType("Success");
      setMessage(t("Please verify your mail again"));
      setShowAlert(true);
    } catch (error) {
      setType("Danger");
      setMessage(error.response?.data?.message || t("Something went wrong."));
      setShowAlert(true);
    }
  };
  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />
      <div className="userform_wrap">
        <Container fluid>
          <Row className="align-items-center justify-content-between">
            <Col lg={6}>
              <UserFormSide pageTitle={t("Member login")} />
              <div className="text-center">
                <img src={LoginImg} alt="" />
              </div>
            </Col>
            <Col lg={6}>
              <section className="user_form">
                <Container>
                  <Row className="justify-content-center">
                    <Col xl={8} lg={10} md={10}>
                      <div className="boxwrap p-md-5 p-4">
                        {!isEmailVerified && (
                          <span className="verify_warn">
                            It's look like your account is pending for
                            verification.{" "}
                            <a onClick={resendVerification} className="verify_link">
                              Send verification email again
                            </a>
                          </span>
                        )}
                        <h2>{t("Login")}</h2>
                        <p className="mb-3">
                          {t("Sign in to your account to continue")}
                        </p>
                        <form onSubmit={handleSubmit(checkUser)}>
                          <Row>
                            <Col md={12}>
                              <div className="mb-3">
                                <label htmlFor="" className="form-label">
                                  {t("Email address")}
                                  <span>*</span>
                                </label>
                                <input
                                  type="email"
                                  className={`form-control ${
                                    errors.email ? "is-invalid" : ""
                                  }`}
                                  id="email"
                                  name="email"
                                  {...register("email", {
                                    required: "Email is required",
                                  })}
                                />
                                {errors.email && (
                                  <div className="invalid-feedback">
                                    {errors.email.message}
                                  </div>
                                )}
                              </div>
                            </Col>
                            <Col md={12}>
                              <div className="mb-3">
                                <div className="d-flex align-items-center justify-content-between">
                                  <label htmlFor="" className="form-label">
                                    {t("Password")}
                                    <span>*</span>
                                  </label>
                                </div>
                                <input
                                  type="password"
                                  className={`form-control ${
                                    errors.password ? "is-invalid" : ""
                                  }`}
                                  id="password"
                                  {...register("password", {
                                    required: "Password is required",
                                  })}
                                />
                                {errors.password && (
                                  <div className="invalid-feedback">
                                    {errors.password.message}
                                  </div>
                                )}
                              </div>
                            </Col>
                            <div className="text-start mb-4 mt-2">
                              <button
                                type="submit"
                                value={t("Sign in")}
                                className="button px-md-4 py-md-3"
                                disabled={loading}
                              >
                                {" "}
                                {loading ? <BtnLoader /> : t("Sign in")}
                              </button>
                            </div>
                           
                          </Row>
                        </form>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </section>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default Login;
